

import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail      
    error: null,
    statusSingle: 'idle', // idle loading success fail  
    errorSingle: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';
// GetViewInstanceHealthShelf/{AuthToken}/{HealthShelfGuid}/
export const fetchHealthShelfs = createAsyncThunk('healthshelfsingle/get', async (incomingVariable, thunkAPI) => {    

    try {
        const response = await axios.get(WELLSUITE + "GetViewInstanceHealthShelf/" + incomingVariable.AuthToken + "/" +  incomingVariable.HealthShelfId_Guid +"/")
        const data = await response.data

        return data
    } catch (err) {
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})


const healthshelfSlice = createSlice({
    name: 'healthshelfs',
    initialState,
    reducers: {        
        healthshelfClear(state, action) {
            //state.entities = initialState keeping single articles during the session
            state.status = "idle"
            state.statusSingle = "idle"
            
        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(fetchHealthShelfs.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchHealthShelfs.fulfilled, (state, action) => {
                const Success = action.payload.Success
                //console.log('payload', action.payload)
                if (Success===true){
                    state.statusSingle = 'success'
                    const loadedData = action.payload.Info[0]                   
                    
                    state.entities[loadedData.Guid] = loadedData
                }else {
                    state.statusSingle = 'error'
                    state.error = action.payload.Status[0]
                }

            })
            .addCase(fetchHealthShelfs.rejected, (state, action) => {
                state.error = action.error.message
                console.log('failed')
            })
            
            
    }
})

export const { healthshelfClear} = healthshelfSlice.actions

export default healthshelfSlice.reducer

export const selectHealthShelfEntities = (state) => state.healthshelfs.entities

export const selectHealthShelfs = createSelector(selectHealthShelfEntities, (entities) =>
    Object.values(entities)
)

export const selectHealthShelfById = (state, HealthShelfId_Guid) => {
    return selectHealthShelfEntities(state)[HealthShelfId_Guid]
}

